import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";

const Cell = ({ k, v, c, testid, sub }) => (
  <div className="p-4 border-r border-b border-line" data-testid={testid}>
    <p className="label-xs">{k}</p><p className="font-mono text-xl font-extrabold mt-2 tabular" style={{ color: c }}>{v}</p>
    {sub && <p className="font-mono text-[10px] text-white/35 mt-1">{sub}</p>}
  </div>
);

export const OpsPulse = ({ m }) => (
  <div className="grid grid-cols-2 md:grid-cols-7 border-l border-line bg-surface mt-0" data-testid="ops-pulse">
    <div className="p-4 border-r border-b border-line md:col-span-2" data-testid="ops-velocity">
      <p className="label-xs">Chargeback velocity · {m.velocity_avg}/day</p>
      <div className="h-12 mt-2"><ResponsiveContainer><BarChart data={m.velocity}><XAxis dataKey="day" hide /><Tooltip contentStyle={{ background: "#000", border: "1px solid #222", fontSize: 11 }} /><Bar dataKey="count" fill="#FF2BD6" /></BarChart></ResponsiveContainer></div>
    </div>
    <Cell k="Evidence ready" v={`${m.evidence_ready_pct}%`} c="var(--brand)" sub={`${m.sealed_pct}% sealed`} testid="ops-evidence-ready" />
    <Cell k="Staged letters" v={m.staged} c="#FF2BD6" sub={`${m.drafts} drafts`} testid="ops-staged" />
    <Cell k="Won this week" v={m.won_this_week} c="var(--brand)" testid="ops-won-week" />
    <Cell k="Due ≤ 5 days" v={m.due_5d} c="#F87171" sub={`${m.open} open`} testid="ops-due" />
    <Cell k="Mode" v={m.dry_run ? "DRY-RUN" : "LIVE"} c={m.dry_run ? "#37E5D7" : "#FFB800"} testid="ops-mode" />
  </div>
);
